import React from 'react';
import Reflux from 'reflux';
import {Link} from 'react-router-dom';
import AppActions from '../AppActions';
import AppStore from '../AppStore';
import ProfileStore from '../stores/ProfileStore';

export default class Profile extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            isUserFollowed: false
        };
        this.stores = [AppStore, ProfileStore];
    }
    followUser = () => {
        this.props.profile.followersCount ++;
        AppActions.followUser(this.props.profile._id);
    }
    unfollowUser = () => {
        this.props.profile.followersCount --;
        AppActions.unfollowUser(this.props.profile._id);
    }
    followUnfollow = () => {
        this.state.isUserFollowed ? this.unfollowUser() : this.followUser();
    }
    componentWillReceiveProps () {
        this.checkIfFollowed();
    }

    checkIfFollowed = () => {
        if (this.state.userData && this.state.userData.following) {
            let index = this.state.userData.following.indexOf(this.props.profile._id);
            this.setState({isUserFollowed: (index >= 0)});
        }
    }

    render () {
        let profile = this.props.profile;

        return <div className='row headerProfile space-top'>
          <div className='container-gral'>
            <div className='content-profile'>
              <div className='profileName'>
                <div className='relative content-profile-top'>
                  <p className='country'><img src='/images/flagarg.jpg' /></p>
                  <div className='icon-profile'>
                    <object type='image/jpg' data={profile.profile_image ? profile.profile_image.sizeSmall : '/images/icons/default-big.jpg'}>
                      <img src='/images/icons/default-big.jpg' />
                    </object>
                  </div>
                </div>
                <div className='txt-profile'>
                  <h4>{profile.screen_name}</h4>
                  {this.props.owner
                    ? <a className='btn btn-primary waves-effect waves-light config_btn' href='/config'><i className='fa fa-cog' /></a>
                    : <button className='btn btn-primary waves-effect waves-light' onClick={this.followUnfollow}>{this.state.isUserFollowed ? 'Dejar de seguir' : 'Seguir'}</button>
                  }

                  <ul className='numbers-user'>
                    <li>
                      <Link to={'/p/' + profile.username}>
                        <span>{this.props.topsCount}</span>
                        <p>Tops</p>
                      </Link>
                    </li>
                    <li>
                      <Link to={'/p/' + profile.username + '/followers'}>
                        <span>{profile.followersCount ? profile.followersCount : 0}</span>
                        <p>Seguidores</p>
                      </Link>
                    </li>
                    <li>
                      <Link to={'/p/' + profile.username + '/following'}>
                        <span>{profile.followingCount ? profile.followingCount : 0}</span>
                        <p>Seguidos</p>
                      </Link>
                    </li>
                    <li>
                      <Link to={'/p/' + profile.username + '/favourites'}>
                        <span>{this.state.userFavs ? this.state.userFavs.length : 0}</span>
                        <p>Favoritos</p>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>;
    }
};



// WEBPACK FOOTER //
// ./src/sections/Profile.js